module.exports = __webpack_public_path__ + "img/plain_btc.f646e591.svg";